export const categories = [
  { id: 'hot', name: '热门推荐', slug: 'hot', icon: 'ri-fire-line', description: '全网最热黑料实时推荐，每日更新热门吃瓜内容' },
  { id: 'celebrity', name: '明星塌房', slug: 'celebrity', icon: 'ri-star-line', description: '娱乐圈明星翻车、塌房事件全记录' },
  { id: 'influencer', name: '网红翻车', slug: 'influencer', icon: 'ri-user-smile-line', description: '各大平台网红翻车现场还原与深度解析' },
  { id: 'expose', name: '独家爆料', slug: 'expose', icon: 'ri-spy-line', description: '一手独家内幕消息，深度挖掘不为人知的黑料' },
  { id: 'industry', name: '行业内幕', slug: 'industry', icon: 'ri-building-line', description: '揭秘各个行业不为人知的内幕与潜规则' },
  { id: 'entertainment', name: '综艺现场', slug: 'entertainment', icon: 'ri-live-line', description: '综艺节目翻车、尴尬瞬间与节目幕后真相' },
];